import React from "react";
import { useMutation } from "@apollo/client";
import {ACA_BATCH_XLSX_UPLOAD} from "../../../schemas/aca";

export type AcaUploadFileI = {
    callback: (a:AcaSingleUploadI) => void;
}

export type AcaSingleUploadI = {
    url: string;
    filename: string;
    error?: string;
}

const AcaUploadXLSXFile = ({ callback }: AcaUploadFileI) => {
    const [mutate, { loading, error }] = useMutation(ACA_BATCH_XLSX_UPLOAD);
    const onChange = async ({
                                target: {
                                    validity,
                                    files: [file]
                                }
                            }: any) => {
        if (validity.valid) {
            const res = await mutate({ variables: { file } })
            callback(res?.data?.acaUploadBatchXLSX)
        }
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <div>{JSON.stringify(error, null, 2)}</div>;

    return (
        <React.Fragment>
            <input type="file" required onChange={onChange} accept=".xlsx" />
        </React.Fragment>
    );
};

export default AcaUploadXLSXFile;